/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_B2_TInputs */

const en_mk_abt_b2_t = /** @type {(inputs: Mk_Abt_B2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing may need installing`)
};

const id_mk_abt_b2_t = /** @type {(inputs: Mk_Abt_B2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak boleh ada yang dipasang`)
};

/**
* | output |
* | --- |
* | "Nothing may need installing" |
*
* @param {Mk_Abt_B2_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_b2_t = /** @type {((inputs?: Mk_Abt_B2_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_B2_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_b2_t(inputs)
	return en_mk_abt_b2_t(inputs)
});